// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import BaseAction from '../../components/base/base-action';
import dialogsStore, { IDialogsStoreState, IStoredDialogState } from './dialogs-store';
import _ from 'lodash';

export interface IDialogOptions<T> {
    step?: string;
    zIndexShift?: number;
    containerHeight?: number;
    data: T;
}

function log(...params: any[]): void {
//   console.log.apply(console, params);
}

class DialogsActions extends BaseAction {
    public dispatchEventName: string = 'setDialogsState';

    private safeModifyStoredDialogState<T>(
        dialogId: string,
        transform: (state: IStoredDialogState<T>) => void
    ): void {
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        const storedState: IStoredDialogState<T> = _.clone(
            (dialogsStore.getImmediateState() || {})[dialogId] || {}
        ) as any;
        const updated = {} as any;
        transform(storedState);
        updated[dialogId] = storedState;
        this.dispatch(updated);
    }

    private static setOptions<T>(state: IStoredDialogState<T>, options?: IDialogOptions<T>): void {
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        const newOptions: IDialogOptions<T> = _.assign(
            {},
            state.initialOptions || {},
            options || {}
        ) as any;
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        newOptions.data = _.assign(
            {},
            (state.initialOptions && state.initialOptions.data) || {},
            newOptions.data || {}
        ) as any;
        state.data = newOptions.data;
        state.step = newOptions.step;
        state.zIndexShift = newOptions.zIndexShift;
        state.containerHeight = newOptions.containerHeight;
        state.initialOptions = newOptions;
        state.processing = false;
        state.visible = false;
    }

    public registerDialog<T>(dialogId: string, options?: IDialogOptions<T>): void {
        log('DialogsActions.registerDialog', dialogId, options);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            DialogsActions.setOptions(state, options);
        });
    }

    public show<T>(dialogId: string, options?: IDialogOptions<T>): void {
        log('DialogsActions.show', dialogId, options);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            DialogsActions.setOptions(state, options);
            state.visible = true;
        });
    }

    public hide(dialogId: string): void {
        log('DialogsActions.hide', dialogId);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            state.visible = false;
        });
    }

    public hideAll(): void {
        log('DialogsActions.hideAll');
        const storedState = dialogsStore.getImmediateState() as IDialogsStoreState;
        _.keys(storedState).forEach(dialogId => {
            if (storedState[dialogId] && storedState[dialogId].visible) {
                this.hide(dialogId);
            }
        });
    }

    public setStep(dialogId: string, step: string, containerHeight?: number): void {
        log('DialogsActions.setStep', dialogId, step, containerHeight);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            const curStep = state.step;
            state.prevSteps = state.prevSteps || [];
            state.prevSteps.push({
                step: curStep,
                containerHeight: state.containerHeight
            });
            state.step = step;
            if (containerHeight) {
                state.containerHeight = containerHeight;
            }
        });
    }

    public goToPrevStep(dialogId: string): void {
        log('DialogsActions.goToPrevStep', dialogId);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            state.prevSteps = state.prevSteps || [];
            const prevStep = state.prevSteps.pop();
            if (prevStep) {
                state.step = prevStep.step;
                if (prevStep.containerHeight) {
                    state.containerHeight = prevStep.containerHeight;
                }
            }
        });
    }

    public setZIndexShift(dialogId: string, zIndexShift: number): void {
        log('DialogsActions.setZIndexShift', dialogId, zIndexShift);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            state.zIndexShift = zIndexShift;
        });
    }

    public updateData<T>(dialogId: string, data: T): void {
        log('DialogsActions.updateData', dialogId, data);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<T>) => {
            state.data = _.assign({}, state.data, data) as any;
        });
    }

    public setDialogProcessing(dialogId: string, processing: boolean): void {
        log('DialogsActions.setDialogProcessing', dialogId, processing);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            if (processing) {
                // reset error when start processing
                state.error = undefined;
            }
            state.processing = processing;
        });
    }

    public setDialogError(dialogId: string, error: string): void {
        log('DialogsActions.setDialogError', dialogId, error);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            // reset processing when error
            state.processing = false;
            state.error = error;
        });
    }

    public resetDialogError(dialogId: string): void {
        log('DialogsActions.resetDialogError', dialogId);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            state.error = undefined;
        });
    }

    public hideAndResetDialog(dialogId: string): void {
        log('DialogsActions.hideAndResetDialog', dialogId);
        this.safeModifyStoredDialogState(dialogId, (state: IStoredDialogState<any>) => {
            DialogsActions.setOptions(state, state.initialOptions);
            state.error = undefined;
            state.processing = false;
            state.visible = false;
        });
    }
}

const actions = new DialogsActions();
// tslint:disable-next-line:no-default-export (autogenerated)
export default actions;
